@if (matchesSearch(node(), searchTerm())) {
  <div class="tree-node" [class.tree-root]="isRoot()">
    <div
      class="node-row"
      [class.expandable]="hasChildren"
      [class.highlight]="isHighlighted"
      [attr.tabindex]="hasChildren ? 0 : null"
      [attr.role]="hasChildren ? 'button' : null"
      (click)="onToggle()"
      (keydown.enter)="onToggle()"
      (keydown.space)="$event.preventDefault(); onToggle()"
    >
      @if (hasChildren) {
        <div class="expand-icon" [class.expanded]="isExpanded">
          <mat-icon fontSet="material-icons-outlined">chevron_right</mat-icon>
        </div>
      } @else {
        <div class="expand-spacer"></div>
      }

      <span class="node-name">{{ node().name }}</span>

      @if (node().required) {
        <span class="required-mark">*</span>
      }

      <span class="type-badge" [class]="typeClass">{{ node().type }}</span>

      @if (hasChildren) {
        <span class="child-count">{{ childCount }} {{ childrenLabel | transloco }}</span>
      }

      @if (node().description && !isRoot()) {
        <span class="node-description">{{ node().description }}</span>
      }

      @if (node().example !== undefined) {
        <span class="node-example">{{ node().example }}</span>
      }
    </div>

    @if (hasChildren) {
      <div class="tree-children" [class.collapsed]="!isExpanded">
        @for (child of node().children; track child.name) {
          @if (matchesSearch(child, searchTerm())) {
            <app-data-model-tree-node
              [node]="child"
              [path]="nodePath"
              [searchTerm]="searchTerm()"
              [expandedNodes]="expandedNodes()"
              (toggleExpand)="onChildToggle($event)"
            />
          }
        }
      </div>
    }
  </div>
}
